import request from 'reqwest';
import when from 'when';
import MerchantConstants from '../constants/MerchantConstants';
import AuthService from '../services/AuthService';
import constants from "../constants/BaseConstants";

class MerchantService {
   async updateMerchant(dataMerchant, openHours) {
     try {
       await this.updateOpenHours(openHours);
       let merchant = await this.update(dataMerchant);
       return merchant;
     } catch(e) {
       return e;
     }
   }

   update(data) {
    return when(request({
      url: MerchantConstants.MERCHANT_URL + AuthService.getUser().id,
      method: 'PUT',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      data: JSON.stringify({
        merchant: {
          line1: data.address.line1,
          line2: data.address.line2,
          city: data.address.city,
          state: data.address.state,
          zip: data.address.zip,
          contact_email: data.contact_email,
          description: data.description,
          display_phone: data.display_phone,
          name: data.name,
          website: data.website,
          owner_first_name: data.owner_first_name,
          owner_last_name: data.owner_last_name,
          password: data.password,
          visible_to_customers: data.visible_to_customers,
          latitude: data.latitude,
          longitude: data.longitude,
          types: data.types_id == null ? data.types_id: data.types_id.join(",")
        }
      })
    })).then((res) => res,(err) => err);
  }

  get() {
    return when(request({
      url: MerchantConstants.MERCHANT_URL + AuthService.getUser().id,
      method: 'GET',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      }
    }));
  }

  updateOpenHours(data) {
    when(request({
      url: MerchantConstants.MERCHANT_OPENING_HOURS_URL,
      method: 'POST',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      data: JSON.stringify(data)
    })).then((res) => res,(err) => err);
  }

  getTypes() {
    return when(request({
      url: constants.BASE_URL + 'admin/merchant_types',
      headers: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      method: 'GET',

      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }
}

export default new MerchantService()



/** WEBPACK FOOTER **
 ** ./src/services/MerchantService.js
 **/